import moment from "moment";
import { Badge } from "src/components/ui/Badge";

const AttendanceOnDateCard = ({ selectedRecord }) => {
  return (
    <div className="bg-card border p-4 rounded-lg shadow-md w-full max-w-md space-y-2">
      <div className="flex gap-4 justify-between">
        <p className="font-medium mb-2 text-primary">
            {moment(selectedRecord.date).format("MMM Do YY")}
        </p>
        <Badge
          className={`font-medium px-3 rounded-full ${
            selectedRecord.attendance_status === "FULLDAY"
              ? "bg-green-100 text-green-600"
              : selectedRecord.attendance_status === "ABSENT"
              ? "bg-red-100 text-red-600"
              : selectedRecord.attendance_status === "HALFDAY"
              ? "bg-amber-100 text-amber-600"
              : ""
          }`}
        >
          {selectedRecord.attendance_status}
        </Badge>
      </div>

      <div className="flex justify-between gap-4">
        <p>
          Check-in:{" "}
          {selectedRecord.checkin_time
            ? moment(selectedRecord.checkin_time).format("LT")
            : "—-:--"}
        </p>
      </div>
    </div>
  );
};

export default AttendanceOnDateCard;
